import { render, staticRenderFns } from "./sys_iframe.vue?vue&type=template&id=b8d75164"
import script from "./sys_iframe.vue?vue&type=script&lang=js"
export * from "./sys_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports